import { OnDestroy } from '@angular/core';
import { FiHighlightService } from '@fi-shared/fi-highlight/fi-highlight.service';
import { Component, ElementRef, OnInit, Renderer2, ViewEncapsulation } from '@angular/core';
import { FiDocumentLayoutItemTextBase } from '../layout-item-text-base';
import { TemplateLayoutLanguageService } from '@fi-app/template/template-layout-language.service';
import { ITemplatePlaceHolderControlContent } from '@fi-app/template/template';
import { TextEditorSelectionElementBuilderService } from '@fi-shared/fi-text-editor/fi-text-editor-helper-services/text-editor-selection-element-builder.service';
import { FiTextPanelType } from '@fi-shared/fi-text-panel/fi-text-panel-type';

@Component({
    selector: 'fi-document-layout-item-simple-text',
    templateUrl: './layout-item-simple-text.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./layout-item-simple-text.component.scss'],
    host: { class: 'fi-document-layout-item-simple-text' },
    standalone: false,
})
export class FiDocumentLayoutItemSimpleTextComponent extends FiDocumentLayoutItemTextBase implements OnInit, OnDestroy {
    constructor(
        public renderer: Renderer2,
        public elementRef: ElementRef,
        templateLayoutLanguageService: TemplateLayoutLanguageService,
        textEditorSelectionElementBuilderService: TextEditorSelectionElementBuilderService,
        private highlightService: FiHighlightService,
    ) {
        super(textEditorSelectionElementBuilderService, templateLayoutLanguageService);
    }

    ngOnInit() {
        super.ngOnInit();
        this.renderer.addClass(this.elementRef.nativeElement, 'item-simple-text');
    }

    getContent(contentTextValue: string) {
        return this.highlightService.getHighlightLayout(contentTextValue);
    }

    textChange($event, content: ITemplatePlaceHolderControlContent) {
        this.contentChange.emit($event);
        content.modified = true;
    }

    ngOnDestroy() {
        this.highlightService.setHighlightText(undefined);
    }

    protected readonly FiTextPanelType = FiTextPanelType;
}
